module.exports = __webpack_public_path__ + "img/x3_5894e7680.png";